import {charcoal} from '../sass/base/_exports.sass';

export const TrashIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={color}
        d="M24 6.4h8v3.2h-3.2v20.8a1.6 1.6 0 0 1-1.6 1.6H4.8a1.6 1.6 0 0 1-1.6-1.6V9.6H0V6.4h8V1.6A1.6 1.6 0 0 1 9.6 0h12.8A1.6 1.6 0 0 1 24 1.6Zm1.6 3.2H6.4v19.2h19.2ZM11.2 3.2v3.2h9.6V3.2Z"
      />
    </svg>
  );
};
